// @flow

import Dinero from "dinero.js"
import {transform, isEqual, isObject} from "lodash"

export const normalize = (input: Array<Object>): Object => {
  var ret = {}
  input.forEach((item: any) => {
    if (item.id) {
      const {id, ...itemRest} = item
      ret[item.id] = itemRest
      ret[item.id]["id"] = id
    }
  })
  return ret
}

export const getTimeZone = (date: Date): string => {
  const offset = date.getTimezoneOffset()
  const o = Math.abs(offset)
  return (
    (offset < 0 ? "+" : "-") +
    ("00" + Math.floor(o / 60)).slice(-2) +
    ":" +
    ("00" + (o % 60)).slice(-2)
  )
}

window.getTimeZone = getTimeZone

// TODO test
// The amount is a string that is guaranteed
// to be a parseable to an integer
export const toDinero = (amount: string): any =>
  Dinero({
    amount: parseInt(amount),
    currency: "EUR",
  }).setLocale("nl-NL")

export default Dinero

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export const difference = (object: any, base: any) =>
  transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      result[key] =
        isObject(value) && isObject(base[key])
          ? difference(value, base[key])
          : value
    }
  })
